<template>
  <ac-modal
    :model-value="modelValue"
    @update:modelValue="close($event)"
  >
    <div
      class="modal-choose-club"
    >
      <div class="modal-choose-club_header header">
        <div class="modal-choose-club_row">
          <div class="header_empty"></div>

          <div class="header_title">{{ $t('navigationPage') }}</div>

          <div class="header_close" @click="close(false)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_3513_9588)">
                <path d="M12 10.586L16.243 6.34299C16.6335 5.95252 17.2665 5.95252 17.657 6.34299C18.0475 6.73345 18.0475 7.36652 17.657 7.75699L13.414 12L17.657 16.243C18.0475 16.6335 18.0475 17.2665 17.657 17.657C17.2665 18.0475 16.6335 18.0475 16.243 17.657L12 13.414L7.75699 17.657C7.36652 18.0475 6.73345 18.0475 6.34299 17.657C5.95252 17.2665 5.95252 16.6335 6.34299 16.243L10.586 12L6.34299 7.75699C5.95252 7.36652 5.95252 6.73345 6.34299 6.34299C6.73345 5.95252 7.36652 5.95252 7.75699 6.34299L12 10.586Z" fill="#0E2242"/>
              </g>
              <defs>
                <clipPath id="clip0_3513_9588">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>

<!--        TODO Пока убрать-->
<!--        <div class="modal-choose-club_row header_subTitle">{{ $t('navigationPage') }}</div>-->
      </div>

      <div class="modal-choose-club_body body">
        <div
          v-for="(club) in communities"
          :key="`club-${club.id}`"
          class="club"
          @click="handlerChooseClub(club)"
        >
          <div class="club_title">
            {{ club.title }}
          </div>
        </div>
      </div>
    </div>
  </ac-modal>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { Community } from '@web/types/Community'
import AcModal from '@ui-kit/components/AcModal.vue'

export default defineComponent({
  name: 'ModalChooseClub',
  components: {
    AcModal
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    communities: {
      type: Array as PropType<Community[]>,
      default: () => ([])
    }
  },
  emits: ['update:modelValue', 'chooseClub'],
  setup (props, ctx) {
    function handlerModelValue (val) {
      ctx.emit('update:modelValue', val)
    }

    function close (isClose) {
      if (!isClose) {
        handlerModelValue(false)
      }
    }

    function handlerChooseClub (club) {
      ctx.emit('chooseClub', club)
    }

    return {
      handlerModelValue,
      close,
      handlerChooseClub
    }
  }
})
</script>

<style lang="scss" scoped>
.modal-choose-club {
  width: 100%;
  max-width: 350px;
  background-color: var(--ac-color-white);
  box-shadow: 0 0 14px rgba(10, 33, 67, 0.1);
  border-radius: 12px;
  padding: 20px 0;
  user-select: none;
  max-height: 90%;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;

  &_row {
    display: flex;
    flex-flow: row nowrap;
    align-self: center;
    justify-content: space-between;
    margin-bottom: 10px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &_header {
    margin-bottom: 20px;
  }
}

.header {
  padding: 0 20px;
  width: 100%;

  &_empty {
    width: 24px;
  }

  &_title {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: var(--ac-color-black);
  }

  &_subTitle {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: var(--ac-color-dark-gray);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &_close {
    flex: 0 0 auto;
    cursor: pointer;
    width: 24px;
  }
}

.body {
  padding: 0 20px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.club {
  border: 1px solid var(--ac-color-blue);
  margin-bottom: 14px;
  position: relative;
  width: 310px;
  //height: 120px;
  overflow: hidden;
  cursor: pointer;
  background-color: white;
  border-radius: 8px;
  padding: 18px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  &_title {
    position: relative;

    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: var(--ac-color-blue);
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
